"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/web.dom.iterable");
var _decorateConfigItem = require("@/api/decorate/decorateConfigItem.js");
var _decorateConfig = require("@/api/decorate/decorateConfig.js");
var _popupConfig = require("@/api/popup/popupConfig.js");
var _memberManagement = require("@/api/member/memberManagement.js");
var _popupTypes = require("@/utils/popupTypes.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MenuCarouselmage',
  props: {
    pageKey: {
      type: String,
      default: ''
    },
    moduleKey: {
      type: String,
      default: ''
    },
    xcxType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      imagePrefix: '',
      list: [],
      selectedItems: [],
      // 用于预览功能的选中项
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      allPage: [],
      dialogTitle: '添加滚动播图',
      isEdit: false,
      currentId: null,
      formData: {
        title: '',
        recommendType: 1,
        recommendContent: '',
        recommendContentSub: null,
        recommendContentId: null,
        recommendContentParam: null,
        startTime: '',
        endTime: '',
        sort: 1,
        visible: true,
        images: [{
          url: '',
          jumpType: 'none',
          customUrl: '',
          systemPage: ''
        }],
        interval: 3,
        cornerRadius: 0,
        // 新增的条件字段
        isVip: 1,
        // 是否会员 (1:全部, 2:是, 3:否)
        vipGradeRadio: 1,
        // 会员级别条件 (1:lv1及以上, 2:lv2及以上, 3:lv3及以上, 4:lv4, 5:lv5)
        userType: 1,
        // 用户类型 (1:全部, 2:新用户, 3:老用户)
        showImage: null,
        // 展示图片
        sendScene: [],
        // 发送场景
        showPlatform: [],
        // 展示平台
        isAddQy: 1,
        // 添加企微 (1:全部, 2:是, 3:否)
        isNewPeopleCoupon: 1,
        // 新人券是否过期 (1:全部, 2:过期, 3:未过期)
        isSaleOrder: 1,
        // 是否下单 (1:全部, 2:下过单, 3:未下过单)
        weekDays: [],
        // 星期选项 (1-7代表周一到周日)
        // 分组类型相关字段
        cdpGrpType: 0,
        // 分组类型 (0:不匹配, 1:CDP分组, 2:消费行为)
        cdpGrpId: null,
        // 分组ID
        selectedStores: [] // 适用门店id (空=全部门店)
      },
      storeSearchText: '',
      // 门店搜索文本
      storeTreeData: [],
      // 树状门店数据
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      expandedKeys: [],
      // 默认展开的节点
      checkedKeys: [],
      // 默认选中的节点
      selectedShopsCount: 0,
      // 已选门店数
      rules: {
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
        recommendType: [{
          required: true,
          message: '请选择推荐类型',
          trigger: 'change'
        }],
        sort: [{
          required: true,
          message: '请输入排序',
          trigger: 'change'
        }],
        recommendContent: [{
          required: true,
          message: '请输入推荐内容',
          trigger: 'change',
          validator: this.validateRecommendContent
        }],
        showImage: [{
          required: true,
          message: '请上传展示图片',
          trigger: 'change'
        }],
        showPlatform: [{
          type: 'array',
          required: true,
          message: '请选择展示平台',
          trigger: 'change'
        }],
        sendScene: [{
          type: 'array',
          required: true,
          message: '请选择发送场景',
          trigger: 'change'
        }],
        weekDays: [{
          type: 'array',
          required: true,
          message: '请选择星期选项',
          trigger: 'change'
        }],
        startTime: [{
          required: true,
          message: '请选择开始时间',
          trigger: 'change'
        }, {
          validator: this.validateTimeRange,
          trigger: 'change'
        }],
        endTime: [{
          required: true,
          message: '请选择结束时间',
          trigger: 'change'
        }, {
          validator: this.validateTimeRange,
          trigger: 'change'
        }]
      },
      pageList: [],
      surveyOptions: [{
        label: '满意度调查',
        value: 'satisfaction'
      }, {
        label: '产品反馈',
        value: 'feedback'
      }, {
        label: '用户体验',
        value: 'ux'
      }],
      weekOptions: [{
        label: '周一',
        value: 1
      }, {
        label: '周二',
        value: 2
      }, {
        label: '周三',
        value: 3
      }, {
        label: '周四',
        value: 4
      }, {
        label: '周五',
        value: 5
      }, {
        label: '周六',
        value: 6
      }, {
        label: '周日',
        value: 7
      }],
      // 图片上传相关属性
      fileList: [],
      // 照片墙文件列表
      previewVisible: false,
      // 预览对话框显示状态
      previewImageUrl: '',
      // 预览图片URL
      currentImageIndex: -1,
      // 当前操作的图片索引
      // CDP分组相关数据
      cdpGroupOptions: [],
      cdpGroupLoading: false
    };
  },
  watch: {
    storeSearchText: function storeSearchText(val) {
      this.$refs.storeTree.filter(val);
    }
  },
  created: function created() {
    // 页面加载时获取已保存的配置
    this.loadConfig();
    // 获取图片前缀
    this.getImagePrefix();
    // 获取页面列表
    this.getPageList();
    // 获取门店树数据
    this.getShopList();
  },
  methods: {
    // 表格"适用门店"列格式化（门店过多时折叠显示）
    storeColumnFormatter: function storeColumnFormatter(row) {
      var storeIds = row.extra && row.extra.storeIds;
      if (!Array.isArray(storeIds) || storeIds.length === 0) {
        return '全部';
      }
      var names = [];
      var _walk = function walk(nodes) {
        nodes.forEach(function (node) {
          if (node.isRegion) {
            _walk(node.children || []);
          } else if (storeIds.includes(node.id)) {
            names.push(node.label);
          }
        });
      };
      _walk(this.storeTreeData);
      var labels = names.length > 0 ? names : storeIds.map(function (id) {
        return String(id);
      });
      if (labels.length > 3) {
        return labels.slice(0, 3).join('、') + " \u7B49 ".concat(labels.length, " \u5BB6\u95E8\u5E97");
      }
      return labels.join('、');
    },
    // 获取门店列表
    getShopList: function () {
      var _getShopList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _popupConfig.getShops)();
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                // 转换数据结构以匹配前端期望的格式
                this.storeTreeData = this.transformShopData(response.data);
                // 设置默认展开的节点为所有顶级节点（使用nodeKey，避免区域id与门店id撞号）
                this.expandedKeys = this.storeTreeData.map(function (item) {
                  return item.nodeKey;
                });
              } else {
                this.$message.error('获取门店列表失败');
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取门店列表错误：', _t);
              this.$message.error('获取门店列表失败');
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getShopList() {
        return _getShopList.apply(this, arguments);
      }
      return getShopList;
    }(),
    // 转换门店数据结构
    transformShopData: function transformShopData(data) {
      // 后端数据里区域id可能与门店storeId撞号、同一门店可能出现在多个区域下，
      // 直接用 id 作为 node-key 会因 key 重复导致 setCheckedKeys 勾选不上部分门店，
      // 因此用 nodeKey 保证唯一（区域 'r'+id、门店 's'+storeId），并对重复门店/区域去重
      var seenRegionIds = new Set();
      var seenStoreIds = new Set();
      var result = [];
      data.forEach(function (region) {
        if (seenRegionIds.has(region.id)) return;
        seenRegionIds.add(region.id);
        // 复制区域信息
        var transformedRegion = {
          id: region.id,
          nodeKey: 'r' + region.id,
          isRegion: true,
          label: region.label,
          children: []
        };

        // 转换子节点（门店），同一门店只保留第一次出现
        if (region.children && region.children.length > 0) {
          region.children.forEach(function (shop) {
            if (seenStoreIds.has(shop.storeId)) return;
            seenStoreIds.add(shop.storeId);
            transformedRegion.children.push({
              id: shop.storeId,
              // 使用storeId作为id
              nodeKey: 's' + shop.storeId,
              label: shop.shopName,
              // 使用shopName作为label
              regId: shop.regId,
              regName: shop.regName
            });
          });
        }
        result.push(transformedRegion);
      });
      return result;
    },
    // 获取页面列表
    getPageList: function () {
      var _getPageList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _popupConfig.queryPageList)();
            case 1:
              response = _context2.sent;
              if (response.code === 200 && response.data) {
                this.allPage = response.data.map(function (item) {
                  return {
                    value: item.pageUrl,
                    label: item.pageName,
                    appid: item.appid,
                    id: String(item.id)
                  };
                });
                this.pageList = this.allPage;
                if (this.formData.recommendType == 3) {
                  this.pageList = this.allPage.filter(function (item) {
                    return item.appid === 'GAGAX' || item.appid === 'DELI';
                  });
                } else if (this.formData.recommendType == 6) {
                  this.pageList = this.allPage.filter(function (item) {
                    return item.appid === 'GAGAS';
                  });
                }
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取页面列表失败:', _t2);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getPageList() {
        return _getPageList.apply(this, arguments);
      }
      return getPageList;
    }(),
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadConfig();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadConfig();
    },
    handleAdd: function handleAdd() {
      this.dialogTitle = '添加滚动播图';
      this.isEdit = false;
      this.dialogVisible = true;
      this.resetForm();
    },
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(row) {
        var _this = this;
        var loadingInstance, response, detailData, extraData, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              loadingInstance = null;
              _context3.prev = 1;
              // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口获取配置项详情
              _context3.next = 2;
              return (0, _decorateConfigItem.getConfigItemDetail)(row.id);
            case 2:
              response = _context3.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200 && response.data) {
                // 解析详情数据
                detailData = response.data;
                extraData = detailData.extra ? JSON.parse(detailData.extra) : {};
                this.dialogTitle = '编辑滚动播图';
                this.isEdit = true;
                this.currentId = detailData.id;
                this.dialogVisible = true;

                // 填充表单数据
                this.formData = {
                  title: extraData.title || '',
                  recommendType: extraData.recommendType || 1,
                  recommendContent: extraData.recommendContent || '',
                  recommendContentId: extraData.recommendContentId != null ? String(extraData.recommendContentId) : null,
                  recommendContentParam: extraData.recommendContentParam || null,
                  startTime: extraData.startTime || '',
                  endTime: extraData.endTime || '',
                  sort: extraData.sort !== undefined ? extraData.sort : 1,
                  visible: extraData.visible !== undefined ? extraData.visible : true,
                  images: extraData.images && extraData.images.length > 0 ? extraData.images : [{
                    url: '',
                    jumpType: 'none',
                    customUrl: '',
                    systemPage: ''
                  }],
                  interval: extraData.interval !== undefined ? extraData.interval : 3,
                  cornerRadius: extraData.cornerRadius !== undefined ? extraData.cornerRadius : 0,
                  // 新增的条件字段
                  isVip: extraData.isVip !== undefined ? extraData.isVip : 1,
                  vipGradeRadio: extraData.vipGradeRadio !== undefined ? extraData.vipGradeRadio : 1,
                  userType: extraData.userType !== undefined ? extraData.userType : 1,
                  showImage: extraData.showImage || null,
                  // 确保 checkbox-group 字段是数组
                  sendScene: Array.isArray(extraData.sendScene) ? extraData.sendScene : [],
                  showPlatform: Array.isArray(extraData.showPlatform) ? extraData.showPlatform : [],
                  isAddQy: extraData.isAddQy !== undefined ? extraData.isAddQy : 1,
                  isNewPeopleCoupon: extraData.isNewPeopleCoupon !== undefined ? extraData.isNewPeopleCoupon : 1,
                  isSaleOrder: extraData.isSaleOrder !== undefined ? extraData.isSaleOrder : 1,
                  weekDays: Array.isArray(extraData.weekDays) ? extraData.weekDays : [],
                  // 星期选项
                  // 分组类型相关字段
                  cdpGrpType: extraData.cdpGrpType !== undefined ? extraData.cdpGrpType : 0,
                  cdpGrpId: extraData.cdpGrpId || null,
                  recommendContentSub: extraData.recommendContentSub || '',
                  // 适用门店 (空=全部门店)
                  selectedStores: Array.isArray(extraData.storeIds) ? extraData.storeIds : []
                };
                if (this.formData.recommendType == 3) {
                  this.pageList = this.allPage.filter(function (item) {
                    return item.appid === 'GAGAX' || item.appid === 'DELI';
                  });
                } else if (this.formData.recommendType == 6) {
                  this.pageList = this.allPage.filter(function (item) {
                    return item.appid === 'GAGAS';
                  });
                }

                // 如果有图片，初始化文件列表
                if (this.formData.showImage) {
                  this.fileList = [{
                    name: '图片',
                    url: this.formData.showImage,
                    uid: Date.now()
                  }];
                }

                // 回填门店树选中状态
                this.selectedShopsCount = this.formData.selectedStores.length;
                this.$nextTick(function () {
                  _this.setCheckedKeysAfterShopDataLoaded();
                });
              } else {
                this.$message.error(response.message || '加载详情失败!');
              }
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t3 = _context3["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('加载详情失败:', _t3);
              this.$message.error('加载详情失败: ' + (_t3.message || '未知错误'));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    handleRemove: function () {
      var _handleRemove = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(row) {
        var _this2 = this;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.$confirm('确定要移除该项吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var response, _t4;
                return regeneratorRuntime.wrap(function (_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.prev = 0;
                      _context4.next = 1;
                      return (0, _decorateConfigItem.deleteConfigItem)(row.id);
                    case 1:
                      response = _context4.sent;
                      if (!(response.code === 200)) {
                        _context4.next = 3;
                        break;
                      }
                      _context4.next = 2;
                      return _this2.loadConfig();
                    case 2:
                      _this2.$message.success('移除成功');
                      _context4.next = 4;
                      break;
                    case 3:
                      _this2.$message.error(response.message || '删除失败!');
                    case 4:
                      _context4.next = 6;
                      break;
                    case 5:
                      _context4.prev = 5;
                      _t4 = _context4["catch"](0);
                      console.error('删除失败:', _t4);
                      _this2.$message.error('删除失败: ' + (_t4.message || '未知错误'));
                    case 6:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4, null, [[0, 5]]);
              }))).catch(function () {
                _this2.$message.info('已取消移除');
              });
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleRemove(_x2) {
        return _handleRemove.apply(this, arguments);
      }
      return handleRemove;
    }(),
    handleToggleVisible: function () {
      var _handleToggleVisible = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(row) {
        var response, _t5;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 1;
              return (0, _decorateConfigItem.enableConfigItem)(row.id);
            case 1:
              response = _context6.sent;
              if (!(response.code === 200)) {
                _context6.next = 3;
                break;
              }
              _context6.next = 2;
              return this.loadConfig();
            case 2:
              this.$message.success("\u66F4\u65B0\u6210\u529F");
              _context6.next = 4;
              break;
            case 3:
              // 如果接口调用失败，恢复开关状态
              row.enable = !row.enable;
              this.$message.error(response.message || '操作失败!');
            case 4:
              _context6.next = 6;
              break;
            case 5:
              _context6.prev = 5;
              _t5 = _context6["catch"](0);
              // 如果接口调用失败，恢复开关状态
              row.enable = !row.enable;
              console.error('操作失败:', _t5);
              this.$message.error('操作失败: ' + (_t5.message || '未知错误'));
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 5]]);
      }));
      function handleToggleVisible(_x3) {
        return _handleToggleVisible.apply(this, arguments);
      }
      return handleToggleVisible;
    }(),
    handleSubmit: function () {
      var _handleSubmit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _this3 = this;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              this.$refs.form.validate(/*#__PURE__*/function () {
                var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(valid) {
                  var loadingInstance, data, response, _t6;
                  return regeneratorRuntime.wrap(function (_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        if (valid) {
                          _context7.next = 1;
                          break;
                        }
                        return _context7.abrupt("return");
                      case 1:
                        // 社区模式：清理"其他"模式遗留的appid（recommendContentId 必须是选中的页面ID）
                        if (_this3.formData.recommendType == 6 && _this3.formData.recommendContentSub == 'GAGAS') {
                          if (!_this3.pageList.some(function (p) {
                            return p.id === _this3.formData.recommendContentId;
                          })) {
                            _this3.formData.recommendContentId = '';
                          }
                          _this3.formData.recommendContent = '';
                        }
                        loadingInstance = null;
                        _context7.prev = 2;
                        data = {
                          id: _this3.isEdit ? _this3.currentId : null,
                          pageCode: _this3.pageKey,
                          optionCode: _this3.moduleKey,
                          title: _this3.formData.title,
                          enable: _this3.formData.visible,
                          extra: JSON.stringify({
                            title: _this3.formData.title,
                            recommendType: _this3.formData.recommendType,
                            recommendContent: _this3.formData.recommendContent,
                            recommendContentId: _this3.formData.recommendContentId,
                            recommendContentParam: _this3.formData.recommendContentParam,
                            startTime: _this3.formData.startTime,
                            endTime: _this3.formData.endTime,
                            sort: _this3.formData.sort,
                            visible: _this3.formData.visible,
                            images: _this3.formData.images,
                            interval: _this3.formData.interval,
                            cornerRadius: _this3.formData.cornerRadius,
                            // 新增的条件字段
                            isVip: _this3.formData.isVip,
                            vipGradeRadio: _this3.formData.vipGradeRadio,
                            userType: _this3.formData.userType,
                            showImage: _this3.formData.showImage,
                            // checkbox-group 字段
                            sendScene: _this3.formData.sendScene,
                            showPlatform: _this3.formData.showPlatform,
                            isAddQy: _this3.formData.isAddQy,
                            isNewPeopleCoupon: _this3.formData.isNewPeopleCoupon,
                            isSaleOrder: _this3.formData.isSaleOrder,
                            weekDays: _this3.formData.weekDays,
                            // 星期选项
                            // 分组类型相关字段
                            cdpGrpType: _this3.formData.cdpGrpType,
                            cdpGrpId: _this3.formData.cdpGrpId,
                            recommendContentSub: _this3.formData.recommendContentSub || '',
                            // 适用门店 (空=全部门店)
                            storeIds: _this3.formData.selectedStores
                          })
                        }; // 显示保存loading状态
                        loadingInstance = _this3.$loading({
                          lock: true,
                          text: '保存中...',
                          spinner: 'el-icon-loading',
                          background: 'rgba(0, 0, 0, 0.7)'
                        });

                        // 调用后端接口保存配置
                        _context7.next = 3;
                        return (0, _decorateConfigItem.saveConfigItem)(data);
                      case 3:
                        response = _context7.sent;
                        // 关闭loading
                        if (loadingInstance) {
                          loadingInstance.close();
                        }
                        if (!(response.code === 200)) {
                          _context7.next = 5;
                          break;
                        }
                        // 保存成功后关闭对话框
                        _this3.dialogVisible = false;
                        // 刷新列表数据
                        _context7.next = 4;
                        return _this3.loadConfig();
                      case 4:
                        _this3.$message.success(_this3.isEdit ? '编辑成功' : '添加成功');
                        _context7.next = 6;
                        break;
                      case 5:
                        _this3.$message.error(response.message || '保存失败!');
                      case 6:
                        _context7.next = 8;
                        break;
                      case 7:
                        _context7.prev = 7;
                        _t6 = _context7["catch"](2);
                        // 关闭loading
                        if (loadingInstance) {
                          loadingInstance.close();
                        }
                        console.error('保存失败:', _t6);
                        _this3.$message.error('保存失败: ' + (_t6.message || '未知错误'));
                      case 8:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7, null, [[2, 7]]);
                }));
                return function (_x4) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }(),
    resetForm: function resetForm() {
      this.currentId = null;
      this.formData = (0, _defineProperty2.default)((0, _defineProperty2.default)({
        title: '',
        recommendType: 1,
        recommendContent: '',
        recommendContentSub: null,
        recommendContentId: null,
        recommendContentParam: null,
        startTime: '',
        endTime: '',
        sort: 1,
        visible: true,
        images: [{
          url: '',
          jumpType: 'none',
          customUrl: '',
          systemPage: ''
        }],
        interval: 3,
        cornerRadius: 0,
        // 新增的条件字段
        isVip: 1,
        vipGradeRadio: 1,
        userType: 1,
        showImage: null,
        sendScene: [],
        // 发送场景
        showPlatform: [],
        // 展示平台
        isAddQy: 1,
        // 添加企微
        isNewPeopleCoupon: 1,
        // 新人券是否过期
        isSaleOrder: 1,
        // 是否下单
        weekDays: [],
        // 星期选项
        // 分组类型相关字段
        cdpGrpType: 0,
        // 分组类型 (0:不匹配, 1:CDP分组, 2:消费行为)
        cdpGrpId: null
      }, "recommendContentSub", ''), "selectedStores", []);
      // 清空门店树选中状态
      this.selectedShopsCount = 0;
      if (this.$refs.storeTree) {
        this.$refs.storeTree.setCheckedKeys([]);
      }
      if (this.$refs.form) this.$refs.form.clearValidate();

      // 重置图片相关字段
      this.fileList = [];
      this.previewImageUrl = '';
      this.previewVisible = false;
    },
    loadConfig: function () {
      var _loadConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var loadingInstance, response, _t7;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              loadingInstance = null;
              _context9.prev = 1;
              if (!(!this.pageKey || !this.moduleKey)) {
                _context9.next = 2;
                break;
              }
              return _context9.abrupt("return");
            case 2:
              // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '加载配置中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口获取配置
              _context9.next = 3;
              return (0, _decorateConfigItem.getDecorateConfigItem)(this.pageKey, this.moduleKey, this.currentPage, this.pageSize);
            case 3:
              response = _context9.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200 && response.records) {
                // 解析配置信息
                this.list = response.records.map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    extra: item.extra ? JSON.parse(item.extra) : {}
                  });
                });
                this.total = response.total;
                this.pageSize = response.size;
              } else if (response.code !== 200) {
                this.$message.error(response.message || '配置加载失败!');
              }
              _context9.next = 5;
              break;
            case 4:
              _context9.prev = 4;
              _t7 = _context9["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('配置加载失败:', _t7);
              this.$message.error('配置加载失败: ' + (_t7.message || '未知错误'));
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[1, 4]]);
      }));
      function loadConfig() {
        return _loadConfig.apply(this, arguments);
      }
      return loadConfig;
    }(),
    handleSave: function () {
      var _handleSave = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _context0.next = 1;
              return this.loadConfig();
            case 1:
              this.$message.success('滚动播图配置保存成功');
            case 2:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this);
      }));
      function handleSave() {
        return _handleSave.apply(this, arguments);
      }
      return handleSave;
    }(),
    handlePreview: function () {
      var _handlePreview = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee1(row) {
        var _loading, response, _t8;
        return regeneratorRuntime.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              _context1.prev = 0;
              // 显示预览loading状态
              _loading = this.$loading({
                lock: true,
                text: '预览中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口预览配置
              _context1.next = 1;
              return (0, _decorateConfigItem.generateQrCode)(row.id, this.xcxType);
            case 1:
              response = _context1.sent;
              // 关闭loading
              _loading.close();
              if (response.code === 200) {
                // 预览成功，显示返回的图片
                if (response.data && response.data.image) {
                  // 显示预览弹窗
                  this.previewImageUrl = response.data.image;
                  this.previewVisible = true;
                } else {
                  this.$message.success('预览成功');
                }
              } else {
                this.$message.error(response.message || '预览失败!');
              }
              _context1.next = 3;
              break;
            case 2:
              _context1.prev = 2;
              _t8 = _context1["catch"](0);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('预览失败:', _t8);
              this.$message.error('预览失败: ' + (_t8.message || '未知错误'));
            case 3:
            case "end":
              return _context1.stop();
          }
        }, _callee1, this, [[0, 2]]);
      }));
      function handlePreview(_x5) {
        return _handlePreview.apply(this, arguments);
      }
      return handlePreview;
    }(),
    handleApply: function () {
      var _handleApply = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function (_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 1;
              return this.loadConfig();
            case 1:
              this.$message.success('滚动播图配置应用成功');
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function handleApply() {
        return _handleApply.apply(this, arguments);
      }
      return handleApply;
    }(),
    // 获取图片前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var response, _t9;
        return regeneratorRuntime.wrap(function (_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _context11.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context11.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context11.next = 3;
              break;
            case 2:
              _context11.prev = 2;
              _t9 = _context11["catch"](0);
              console.error('获取图片前缀失败:', _t9);
            case 3:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 获取图片完整URL
    getImageUrl: function getImageUrl(url) {
      // 如果没有url则返回空
      if (!url) return '';

      // 如果已经是完整URL则直接返回
      if (url.startsWith('http')) {
        return url;
      }

      // 如果有图片前缀，使用图片前缀
      if (this.imagePrefix) {
        // 确保前缀末尾没有斜杠，url开头有斜杠
        var prefix = this.imagePrefix.endsWith('/') ? this.imagePrefix.slice(0, -1) : this.imagePrefix;
        var path = url.startsWith('/') ? url : '/' + url;
        return prefix + path;
      }

      // 如果是相对路径，则加上基础URL
      return process.env.VUE_APP_BASE_API + url;
    },
    // 点击图片预览区域
    handleImageClick: function handleImageClick(index) {
      this.currentImageIndex = index;
      this.$refs.fileInput.click();
    },
    // 文件选择变化
    handleFileChange: function handleFileChange(event) {
      var files = event.target.files;
      if (files.length === 0) return;
      var file = files[0];
      if (this.validateImage(file)) {
        this.uploadImage(file);
      }

      // 清空input值，允许重复选择同一文件
      event.target.value = '';
    },
    // 验证图片文件
    validateImage: function validateImage(file) {
      var isImage = file.type.startsWith('image/');
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!');
        return false;
      }
      return true;
    },
    // 上传图片
    uploadImage: function () {
      var _uploadImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee12(file) {
        var _loading2, response, imageUrl, _t0;
        return regeneratorRuntime.wrap(function (_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              // 显示上传loading状态
              _loading2 = this.$loading({
                lock: true,
                text: '图片上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口上传图片
              _context12.next = 1;
              return (0, _popupConfig.uploadPopupImage)(file);
            case 1:
              response = _context12.sent;
              // 关闭loading
              _loading2.close();
              if (response.code === 200) {
                imageUrl = response.data; // 设置对应图片的URL
                if (this.currentImageIndex >= 0) {
                  this.$set(this.formData.images[this.currentImageIndex], 'url', imageUrl);
                } else {
                  // 如果没有指定索引，则添加新图片
                  this.formData.images.push({
                    url: imageUrl,
                    jumpType: 'none',
                    customUrl: '',
                    systemPage: ''
                  });
                }
                this.$message.success('图片上传成功!');
              } else {
                this.$message.error(response.message || '图片上传失败!');
              }
              _context12.next = 3;
              break;
            case 2:
              _context12.prev = 2;
              _t0 = _context12["catch"](0);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('图片上传失败:', _t0);
              this.$message.error('图片上传失败: ' + (_t0.message || '未知错误'));
            case 3:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this, [[0, 2]]);
      }));
      function uploadImage(_x6) {
        return _uploadImage.apply(this, arguments);
      }
      return uploadImage;
    }(),
    // 添加图片
    addImage: function addImage() {
      this.formData.images.push({
        url: '',
        jumpType: 'none',
        customUrl: '',
        systemPage: ''
      });
    },
    // 移除图片
    removeImage: function removeImage(index) {
      if (this.formData.images.length <= 1) {
        this.$message.warning('至少需要保留一张图片');
        return;
      }
      this.formData.images.splice(index, 1);
    },
    // 处理跳转类型变化
    handleJumpTypeChange: function handleJumpTypeChange(index) {
      // 重置对应的跳转链接
      this.$set(this.formData.images[index], 'customUrl', '');
      this.$set(this.formData.images[index], 'systemPage', '');
    },
    // 外部小程序类型(社区/其他)切换时清空后续输入框
    changeRecommendContentSub: function changeRecommendContentSub() {
      this.formData.recommendContent = '';
      this.formData.recommendContentId = null;
      this.formData.recommendContentParam = null;
    },
    // 推荐类型切换
    changeRecommendInfo: function changeRecommendInfo() {
      var _this4 = this;
      this.formData.recommendContent = '';
      this.formData.recommendContentId = null;
      this.formData.recommendContentParam = null;
      if (this.formData.recommendType == 3) {
        this.pageList = this.allPage.filter(function (item) {
          return item.appid === 'GAGAX' || item.appid === 'DELI';
        });
      } else if (this.formData.recommendType == 6) {
        this.pageList = this.allPage.filter(function (item) {
          return item.appid === 'GAGAS';
        });
      }
      // 触发推荐内容验证
      this.$nextTick(function () {
        _this4.$refs.form.validateField('recommendContent');
      });
    },
    // 处理图片选择
    handleImageChange: function handleImageChange(file, fileList) {
      var _this5 = this;
      if (file.status === 'ready') {
        // 本地预览
        var reader = new FileReader();
        reader.onload = function (e) {
          file.url = e.target.result;
          _this5.fileList = [_objectSpread({}, file)];
        };
        reader.readAsDataURL(file.raw);

        // 开始上传
        (0, _popupConfig.uploadPopupImage)(file.raw).then(function (res) {
          var url = res && res.data || res;
          if (!url) {
            _this5.$message.error('上传失败');
            return;
          }
          // 设置为返回的URL
          _this5.formData.showImage = url;
          // 更新fileList中的展示URL
          _this5.fileList = [{
            name: file.name,
            url: url,
            uid: file.uid
          }];
          _this5.$message.success('图片上传成功');
        }).catch(function (err) {
          console.error('图片上传失败:', err);
          _this5.$message.error('图片上传失败');
          _this5.fileList = [];
          _this5.formData.showImage = null;
        });
      }
    },
    // 处理图片移除
    handleImageRemove: function handleImageRemove(file) {
      this.fileList = [];
      this.formData.showImage = null;
    },
    // 处理表格选择变化
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectedItems = selection;
    },
    // 处理图片预览
    handleImagePreview: function handleImagePreview(file) {
      this.previewImageUrl = file.url;
      this.previewVisible = true;
    },
    // 预览功能
    preview: function () {
      var _preview = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var loadingInstance, ids, previewData, response, _t1;
        return regeneratorRuntime.wrap(function (_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (!(this.selectedItems.length === 0)) {
                _context13.next = 1;
                break;
              }
              this.$message.warning('请至少选择一条数据进行预览');
              return _context13.abrupt("return");
            case 1:
              loadingInstance = null;
              _context13.prev = 2;
              // 获取选中数据的ID
              ids = this.selectedItems.map(function (item) {
                return item.id;
              }); // 构造预览参数
              previewData = {
                ids: ids,
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                xcxType: this.xcxType,
                pageURl: "" // 设置默认页面URL，可根据实际需求调整
              }; // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '预览生成中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用预览接口
              _context13.next = 3;
              return (0, _decorateConfig.previewAdd)(previewData);
            case 3:
              response = _context13.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200) {
                // 预览成功，显示返回的图片
                if (response.data) {
                  // 检查是否有二维码URL直接返回
                  if (response.data.image && typeof response.data.image === 'string') {
                    // 如果返回了二维码URL，显示预览弹窗
                    this.previewImageUrl = response.data.image;
                    this.previewVisible = true;
                  } else {
                    this.$message.success('预览二维码生成成功');
                  }
                } else {
                  this.$message.success('预览二维码生成成功');
                }
              } else {
                this.$message.error(response.message || '预览失败!');
              }
              _context13.next = 5;
              break;
            case 4:
              _context13.prev = 4;
              _t1 = _context13["catch"](2);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('预览失败:', _t1);
              this.$message.error('预览失败: ' + (_t1.message || '未知错误'));
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this, [[2, 4]]);
      }));
      function preview() {
        return _preview.apply(this, arguments);
      }
      return preview;
    }(),
    // 处理超出限制
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning('只能上传一张图片!');
    },
    // 图片上传前验证
    beforeImageUpload: function beforeImageUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false;
      }
      return false; // 阻止自动上传
    },
    // 在门店数据加载完成后设置选中状态
    setCheckedKeysAfterShopDataLoaded: function setCheckedKeysAfterShopDataLoaded() {
      var _this6 = this;
      return new Promise(function (resolve) {
        // 如果门店数据已经加载完成，直接设置选中状态
        if (_this6.storeTreeData && _this6.storeTreeData.length > 0) {
          _this6.setCheckedKeys();
          resolve();
        } else {
          // 如果门店数据还未加载完成，等待数据加载完成后再设置
          var unwatch = _this6.$watch('storeTreeData', function (newVal) {
            if (newVal && newVal.length > 0) {
              _this6.$nextTick(function () {
                _this6.setCheckedKeys();
                unwatch(); // 取消监听
                resolve();
              });
            }
          });
        }
      });
    },
    // 设置选中的门店keys
    setCheckedKeys: function setCheckedKeys() {
      if (this.formData.selectedStores && this.formData.selectedStores.length > 0) {
        // 树的node-key是nodeKey，门店storeId需转换为 's'+storeId 再勾选
        var checkedKeys = this.formData.selectedStores.map(function (id) {
          return 's' + parseInt(id);
        });
        this.checkedKeys = checkedKeys;
        if (this.$refs.storeTree) {
          this.$refs.storeTree.setCheckedKeys(checkedKeys);
        }
      } else {
        // 没有选中的门店，清空选中状态
        this.checkedKeys = [];
        if (this.$refs.storeTree) {
          this.$refs.storeTree.setCheckedKeys([]);
        }
      }
    },
    // 处理门店选择变化
    handleStoreCheck: function handleStoreCheck(data, checked) {
      // 获取当前选中的门店
      var checkedNodes = this.$refs.storeTree.getCheckedNodes();
      // 只获取门店节点（用isRegion判断，避免空区域被当成门店）
      var selectedStores = checkedNodes.filter(function (node) {
        return !node.isRegion;
      });
      // 保存选中的门店ID数组（业务数据仍用原始storeId）
      this.formData.selectedStores = selectedStores.map(function (store) {
        return store.id;
      });
      // 更新选中门店数
      this.selectedShopsCount = this.formData.selectedStores.length;
      console.log('已选择门店ID:', this.formData.selectedStores);
    },
    // 选择全部门店
    selectAllStores: function selectAllStores() {
      // 获取所有门店节点的nodeKey（isRegion判断，区域节点递归子级）
      var _getAllLeafKeys = function getAllLeafKeys(nodes) {
        var keys = [];
        nodes.forEach(function (node) {
          if (node.isRegion) {
            keys = keys.concat(_getAllLeafKeys(node.children || []));
          } else {
            keys.push(node.nodeKey);
          }
        });
        return keys;
      };
      var allLeafKeys = _getAllLeafKeys(this.storeTreeData);
      var currentCheckedKeys = this.$refs.storeTree.getCheckedKeys();

      // 检查当前是否已全选（getCheckedKeys返回的是nodeKey，与allLeafKeys同口径）
      var isAllSelected = allLeafKeys.every(function (key) {
        return currentCheckedKeys.includes(key);
      });
      if (isAllSelected) {
        // 如果已经全选，则取消全选
        this.$refs.storeTree.setCheckedKeys([]);
        this.formData.selectedStores = [];
        this.selectedShopsCount = 0;
        this.$message.info('已取消全选');
      } else {
        // 否则全选
        this.$refs.storeTree.setCheckedKeys(allLeafKeys);
        // 保存选中的门店ID数组（业务数据用原始storeId，不是nodeKey）
        var allStores = [];
        var _collectLeafNodes = function collectLeafNodes(nodes) {
          nodes.forEach(function (node) {
            if (node.isRegion) {
              _collectLeafNodes(node.children || []);
            } else {
              allStores.push(node.id);
            }
          });
        };
        _collectLeafNodes(this.storeTreeData);
        this.formData.selectedStores = allStores;
        this.selectedShopsCount = allStores.length;
        this.$message.success("\u5DF2\u9009\u4E2D ".concat(allStores.length, " \u4E2A\u95E8\u5E97"));
      }
    },
    // 过滤节点
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 获取类型标签样式
    getTypeTagType: function getTypeTagType(recommendType) {
      return _popupTypes.RecommendTypeTagMap[recommendType] || '';
    },
    // 获取类型文本
    getTypeText: function getTypeText(recommendType) {
      console.log('获取类型文本:', recommendType);
      return _popupTypes.RecommendTypeTextMap[recommendType] || '未知类型';
    },
    // 获取推荐内容
    getRecommendContent: function getRecommendContent(row) {
      // 根据推荐类型返回对应的内容
      var content = '';
      var type = row.extra.recommendType;
      var contentId = row.extra.recommendContentId != null ? String(row.extra.recommendContentId) : '';
      if (type === 3 || type === 4 || type === 8 || type === 6 && row.extra.recommendContentSub === 'GAGAS') {
        // 选页面类型：recommendContentId 为页面ID
        var page = this.allPage.find(function (p) {
          return p.id === contentId;
        });
        content = page ? page.label : contentId;
      } else if (type === 6) {
        // 外部小程序-其他：recommendContent 为appid，recommendContentId 为跳转地址
        if (contentId !== '') {
          content = (row.extra.recommendContent || '') + '/' + contentId;
        } else {
          content = row.extra.recommendContent || '';
        }
      } else if (type === 5 || type === 7) {
        // 问卷/红包封面：recommendContentId 为URL
        content = contentId || row.extra.recommendContent || '';
      } else {
        content = row.extra.recommendContent || '';
      }
      // 拼接参数
      if (content && row.extra.recommendContentParam != null && row.extra.recommendContentParam !== '') {
        content += '?' + row.extra.recommendContentParam;
      }
      return content;
    },
    // 验证时间范围
    validateTimeRange: function validateTimeRange(rule, value, callback) {
      if (!this.formData.startTime || !this.formData.endTime) {
        callback();
        return;
      }
      var start = new Date(this.formData.startTime);
      var end = new Date(this.formData.endTime);
      if (start >= end) {
        callback(new Error('开始时间必须早于结束时间'));
      } else {
        callback();
      }
    },
    // 验证推荐内容
    validateRecommendContent: function validateRecommendContent(rule, value, callback) {
      // 如果推荐类型为1(NOTHING)，则不需要验证推荐内容
      if (this.formData.recommendType === 1) {
        callback();
        return;
      }

      // 类型2（活动ID）、类型6-其他（appid）：验证 recommendContent
      if (this.formData.recommendType === 2 || this.formData.recommendType === 6 && this.formData.recommendContentSub === 'other') {
        if (!this.formData.recommendContent) {
          callback(new Error('请输入推荐内容'));
          return;
        }
      } else if (this.formData.recommendType === 6 && this.formData.recommendContentSub === 'GAGAS') {
        // 类型6-社区：验证是否选择了页面
        if (!this.formData.recommendContentId) {
          callback(new Error('请选择推荐页面'));
          return;
        }
      } else if ([3, 4, 5, 7, 8].includes(this.formData.recommendType)) {
        // 选页面/URL类型：验证 recommendContentId
        if (!this.formData.recommendContentId) {
          callback(new Error(this.formData.recommendType === 5 ? '请输入问卷地址' : this.formData.recommendType === 7 ? '请输入红包封面URL' : '请选择推荐页面'));
          return;
        }
      }
      callback();
    },
    // 处理预览弹窗关闭
    handlePreviewClose: function handlePreviewClose() {
      this.previewVisible = false;
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    },
    // 组件销毁前释放资源
    beforeDestroy: function beforeDestroy() {
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    },
    // 处理分组类型变化
    handleCdpGrpTypeChange: function handleCdpGrpTypeChange(value) {
      // 清空之前选择的分组
      this.formData.cdpGrpId = null;
      this.cdpGroupOptions = [];

      // 如果选择了分组类型，则查询对应的分组列表
      if (value !== 0) {
        this.queryCdpGroupList('');
      }
    },
    // 查询CDP分组或消费行为信息
    queryCdpGroupList: function () {
      var _queryCdpGroupList2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee14(query) {
        var response, _t10;
        return regeneratorRuntime.wrap(function (_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              if (!(this.formData.cdpGrpType === 0)) {
                _context14.next = 1;
                break;
              }
              this.cdpGroupOptions = [];
              return _context14.abrupt("return");
            case 1:
              _context14.prev = 1;
              this.cdpGroupLoading = true;
              _context14.next = 2;
              return (0, _popupConfig.queryCdpGroupList)({
                type: this.formData.cdpGrpType,
                name: query
              });
            case 2:
              response = _context14.sent;
              if (response.code === 200) {
                this.cdpGroupOptions = response.data.map(function (item) {
                  return {
                    value: item.id,
                    label: item.name
                  };
                });
              } else {
                this.$message.error('查询分组列表失败: ' + (response.message || '未知错误'));
              }
              _context14.next = 4;
              break;
            case 3:
              _context14.prev = 3;
              _t10 = _context14["catch"](1);
              console.error('查询分组列表错误:', _t10);
              this.$message.error('查询分组列表失败: ' + (_t10.message || '网络错误'));
            case 4:
              _context14.prev = 4;
              this.cdpGroupLoading = false;
              return _context14.finish(4);
            case 5:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this, [[1, 3, 4, 5]]);
      }));
      function queryCdpGroupList(_x7) {
        return _queryCdpGroupList2.apply(this, arguments);
      }
      return queryCdpGroupList;
    }()
  }
};